/**@flow */

export const GetEmployee = "GET_EMPLOYEE";
export const GetEmployeeSuccess = "GET_EMPLOYEE_SUCCESS";
export const GetEmployeeError = "GET_EMPLOYEE_ERROR";
export const GetEmployeeActionSummary = "GET_EMPLOYEE_ACTION_SUMMARY";
export const GetEmployeeActionSummarySuccess = "GET_EMPLOYEE_ACTION_SUMMARY_SUCCESS";
export const GetEmployeeActionSummaryError = "GET_EMPLOYEE_ACTION_SUMMARY_ERROR";
export const GetEmployeeChangelog = "GET_EMPLOYEE_CHANGELOG";
export const GetEmployeeChangelogSuccess = "GET_EMPLOYEE_CHANGELOG_SUCCESS";
export const GetEmployeeChangelogError = "GET_EMPLOYEE_CHANGELOG_ERROR";
export const ResetEmployeeChangelog = "RESET_EMPLOYEE_CHANGELOG";
export const GetActiveClients = "GET_ACTIVE_CLIENTS";
export const GetActiveClientsSuccess = "GET_ACTIVE_CLIENTS_SUCCESS";
export const GetActiveClientsError = "GET_ACTIVE_CLIENTS_ERROR";
export const SearchEmployeeByName = "̇SEARCH_EMPLOYEE_BY_NAME";
export const GetEmployees = "GET_EMPLOYEES";
export const ExportEmployeeReferralHistory = "EXPORT_EMPLOYEE_REFERRAL_HISTORY";
export const ExportEmployeeReferralHistorySuccess = "EXPORT_EMPLOYEE_REFERRAL_HISTORY_SUCCESS";
export const ExportEmployeeReferralHistoryError = "EXPORT_EMPLOYEE_REFERRAL_HISTORY_ERROR";
export const ExportEmployeeDeclinedReferralHistory = "EXPORT_EMPLOYEE_DECLINED_REFERRAL_HISTORY";
export const ExportEmployeeDeclinedReferralHistorySuccess =
  "EXPORT_EMPLOYEE_DECLINED_REFERRAL_HISTORY_SUCCESS";
export const ExportEmployeeDeclinedReferralHistoryError =
  "EXPORT_EMPLOYEE_DECLINED_REFERRAL_HISTORY_ERROR";
export const GetEmployeeReferralHistory = "GET_EMPLOYEE_REFERRAL_HISTORY";
export const EmployeeStartLoading = "EMPLOYEE_START_LOADING";
export const EmployeeStopLoading = "EMPLOYEE_STOP_LOADING";
export const GetEmployeeReferralHistorySuccess = "GET_EMPLOYEE_REFERRAL_HISTORY_SUCCESS";
export const GetEmployeeReferralHistoryError = "GET_EMPLOYEE_REFERRAL_HISTORY_ERROR";
export const SetEmployeesDefaultData = "SET_EMPLOYEES_DEFAULT_DATA";
export const SelectBespokeRecipient = "SET_BESPOKE_RECIPIENT";
export const GetEmployeesSuccess = "GET_EMPLOYEES_SUCCESS";
export const GetEmployeesError = "GET_EMPLOYEES_ERROR";
export const GetEmployeeSchema = "GET_EMPLOYEE_SCHEMA";
export const GetCurrentEmployeeSuccess = "GET_CURRENT_EMPLOYEE_SUCCESS";
export const GetAddEmployeeSchema = "GET_ADD_EMPLOYEE_SCHEMA";
export const GetEmployeeSchemaSuccess = "GET_EMPLOYEE_SCHEMA_SUCCESS";
export const GetAddEmployeeSchemaSuccess = "GET_ADD_EMPLOYEE_SCHEMA_SUCCESS";
export const GetAddEmployeeSchemaError = "GET_ADD_EMPLOYEE_SCHEMA_ERROR";
export const GetEmployeeSchemaError = "GET_EMPLOYEE_SCHEMA_ERROR";
export const SetEmployeesFilter = "SET_EMPLOYEES_FILTER";
export const SetEmployeesSort = "SET_EMPLOYEES_SORT";
export const ToggleAddEmployeeModal = "TOGGLE_ADD_EMPLOYEE_MODAL";
export const ToggleAddEmployeeChooseClientModal = "TOGGLE_ADD_EMPLOYEE_CHOOSE_CLIENT_MODAL";
export const AddEmployee = "ADD_EMPLOYEE";
export const GetEmployeeTempSchema = "GET_EMPLOYEE_TEMP_SCHEMA";
export const GetAddEmployeeError = "GET_EMPLOYEE_ERROR";
export const UpdateEmployeeDetails = "UPDATE_EMPLOYEE_DETAILS";
export const UpdateEmployeeDetailsSuccess = "UPDATE_EMPLOYEE_DETAILS_SUCCESS";
export const UpdateEmployeeDetailsError = "UPDATE_EMPLOYEE_DETAILS_ERROR";

export const DeleteEmployee = "DELETE_EMPLOYEE";
export const DeleteEmployeeSuccess = "DELETE_EMPLOYEE_SUCCESS";
export const DeleteEmployeeError = "DELETE_EMPLOYEE_ERROR";

export const AddAlertExclusion = "ADD_ALERT_EXCLUSION";
export const AddAlertExclusionSuccess = "ADD_ALERT_EXCLUSION_SUCCESS";
export const AddAlertExclusionError = "ADD_ALERT_EXCLUSION_ERROR";
export const UpdateEmployeeDraft = "UPDATE_EMPLOYEE_DRAFT";
export const SetShowExcludeEmployeeFromAlertsAddModal =
  "SET_SHOW_EXCLUDE_EMPLOYEE_FROM_ALERTS_ADD_MODAL";
export const GetEmployeeAlertExclusions = "GET_EMPLOYEE_ALERT_EXCLUSIONS";
export const GetEmployeeAlertExclusionsSuccess = "GET_EMPLOYEE_ALERT_EXCLUSIONS_SUCCESS";
export const GetEmployeeAlertExclusionsError = "GET_EMPLOYEE_ALERT_EXCLUSIONS_ERROR";
export const SetShowRemoveAlertExclusionModal = "SET_SHOW_REMOVE_ALERT_EXCLUSION_MODAL";
export const SetShowEditAlertExclusionModal = "SET_SHOW_EDIT_ALERT_EXCLUSION_MODAL";
export const RemoveAlertExclusion = "REMOVE_ALERT_EXCLUSION";
export const RemoveAlertExclusionSuccess = "REMOVE_ALERT_EXCLUSION_SUCCESS";
export const RemoveAlertExclusionError = "REMOVE_ALERT_EXCLUSION_ERROR";
export const GetEmployeeAlertExclusionSchema = "GET_EMPLOYEE_ALERT_EXCLUSION_SCHEMA";
export const GetEmployeeAlertExclusionSchemaError = "GET_EMPLOYEE_ALERT_EXCLUSION_SCHEMA_ERROR";
export const SetEmployeeAlertExclusionSchema = "SET_EMPLOYEE_ALERT_EXCLUSION_SCHEMA";
export const GetClientAlert = "GET_CLIENT_ALERT";
export const GetClientAlertSuccess = "GET_CLIENT_ALERT_SUCCESS";
export const GetClientAlertError = "GET_CLIENT_ALERT_ERROR";
export const SetExclusionReasonDetails = "SET_EXCLUSION_REASON_DETAILS";
export const UpdateAlertExclusion = "UPDATE_ALERT_EXCLUSION";
export const UpdateAlertExclusionSuccess = "UPDATE_ALERT_EXCLUSION_SUCCESS";
export const UpdateAlertExclusionError = "UPDATE_ALERT_EXCLUSION_ERROR";
export const ClearDataAlertExlusionForm = "CLEAR_DATA_ALERT_EXCLUSION_FORM";

//Employment Details
export const GetEmployeeRoleSummary = "GET_EMPLOYEE_ROLE_SUMMARY";
export const GetEmployeeRoleSummarySuccess = "GET_EMPLOYEE_ROLE_SUMMARY_SUCCESS";
export const GetEmployeeRoleSummaryError = "GET_EMPLOYEE_ROLE_SUMMARY_ERROR";
export const GetEmployeePositionSchema = "GET_EMPLOYEE_POSITION_SCHEMA";
export const GetEmployeePositionSchemaSuccess = "GET_EMPLOYEE_POSITION_SCHEMA_SUCCESS";
export const GetEmployeePositionSchemaError = "GET_EMPLOYEE_POSITION_SCHEMA_ERROR";
export const ToggleAddEmployeePositionModal = "TOGGLE_ADD_EMPLOYEE_POSITIOIN_MODAL";
export const AddEmployeePosition = "ADD_EMPLOYEE_POSITION";
export const DeleteEmployeePosition = "DELETE_EMPLOYEE_POSITION";
export const DeleteEmployeePositionSuccess = "DELETE_EMPLOYEE_POSITION_SUCCESS";
export const DeleteEmployeePositionError = "DELETE_EMPLOYEE_POSITION_ERROR";
export const UpdateEmployeePosition = "UPDATE_EMPLOYEE_POSITION";
export const UpdateEmployeePositionError = "UPDATE_EMPLOYEE_POSITION_ERROR";
export const UpdateEmployeePositionSuccess = "UPDATE_EMPLOYEE_POSITION_SUCCESS";
export const ToggleEditEmployeePositionModal = "TOGGLE_EDIT_EMPLOYEE_POSITION_MODAL";

// Medical Details
export const ToggleAddVaccinationModal = "TOGGLE_ADD_VACCINATION_MODAL";
export const ToggleDeleteVaccinationModal = "TOGGLE_DELETE_VACCINATION_MODAL";
export const GetVaccineTypes = "GET_VACCINE_TYPES";
export const GetEmployeeVaccinations = "GET_EMPLOYEE_VACCINATIONS";
export const GetEmployeeVaccinationsSuccess = "GET_EMPLOYEE_VACCINATIONS_SUCCESS";
export const GetEmployeeVaccinationsError = "GET_EMPLOYEE_VACCINATIONS_ERROR";
export const AddEmployeeVaccination = "ADD_EMPLOYEE_VACCINATION";
export const UpdateEmployeeVaccination = "UPDATE_EMPLOYEE_VACCINATION";
export const AddEmployeeVaccinationSuccess = "ADD_EMPLOYEE_VACCINATION_SUCCESS";
export const AddEmployeeVaccinationError = "ADD_EMPLOYEE_VACCINATION_ERROR";
export const DeleteEmployeeVaccination = "DELETE_EMPLOYEE_VACCINATION";
export const DeleteEmployeeVaccinationSuccess = "DELETE_EMPLOYEE_VACCINATION_SUCCESS";
export const DeleteEmployeeVaccinationError = "DELETE_EMPLOYEE_VACCINATION_ERROR";
export const GetVaccineTypesSuccess = "GET_VACCINE_TYPES_SUCCESS";
export const GetVaccineTypesError = "GET_VACCINE_TYPES_ERROR";
export const ToggleAddMedicationModal = "TOGGLE_ADD_MEDICATION_MODAL";
export const ToggleAddAllergyModal = "TOGGLE_ADD_ALLERGY_MODAL";
export const ToggleAddMedicalHistoryItemModal = "TOGGLE_ADD_MEDICAL_HISTORY_MODAL";
export const ToggleRemoveMedicationModal = "TOGGLE_REMOVE_MEDICATION_MODAL";
export const ToggleRemoveAllergyModal = "TOGGLE_REMOVE_ALLERGY_MODAL";
export const ToggleRemoveMedicalHistoryItemModal = "TOGGLE_REMOVE_MEDICAL_HISTORY_MODAL";
export const GetEmployeeMedications = "GET_EMPLOYEE_MEDICATIONS";
export const GetEmployeeAllergies = "GET_EMPLOYEE_ALLERGIES";
export const GetEmployeeMedicalHistory = "GET_EMPLOYEE_MEDICAL_HISTORY";
export const GetEmployeeMedicationsSuccess = "GET_EMPLOYEE_MEDICATIONS_SUCCESS";
export const GetEmployeeMedicationsError = "GET_EMPLOYEE_MEDICATIONS_ERROR";
export const AddMedication = "ADD_MEDICATION";
export const AddMedicationSuccess = "ADD_MEDICATION_SUCCESS";
export const AddMedicationError = "ADD_MEDICATION_ERROR";
export const UpdateMedication = "UPDATE_MEDICATION";
export const UpdateMedicationSuccess = "UPDATE_MEDICATION_SUCCESS";
export const UpdateMedicationError = "UPDATE_MEDICATION_ERROR";
export const UpdateAllergy = "UPDATE_ALLERGY";
export const UpdateAllergySuccess = "UPDATE_ALLERGY_SUCCESS";
export const UpdateAllergyError = "UPDATE_ALLERGY_ERROR";
export const RemoveMedication = "REMOVE_MEDICATION";
export const RemoveMedicationSuccess = "REMOVE_MEDICATION_SUCCESS";
export const RemoveMedicationError = "REMOVE_MEDICATION_ERROR";
export const GetAddMedicationError = "GET_ADD_MEDICATION_ERROR";
export const GetRemoveMedicationError = "GET_REMOVE_MEDICATION_ERROR";
export const GetMedicationSchema = "GET_MEDICATION_SCHEMA";
export const GetMedicationSchemaError = "GET_MEDICATION_SCHEMA_ERROR";
export const SetMedicationSchema = "SET_MEDICATION_SCHEMA";
export const GetEmployeeAllergiesSuccess = "GET_EMPLOYEE_ALLERGIES_SUCCESS";
export const GetEmployeeAllergiesError = "GET_EMPLOYEE_ALLERGIES_ERROR";
export const GetAllergySchema = "GET_ALLERGY_SCHEMA";
export const GetAllergySchemaError = "GET_ALLERGY_SCHEMA_ERROR";
export const AddAllergy = "ADD_ALLERGY";
export const AddAllergySuccess = "ADD_ALLERGY_SUCCESS";
export const AddAllergyError = "ADD_ALLERGY_ERROR";
export const GetAddAllergyError = "GET_ADD_ALLERGY_ERROR";
export const GetRemoveAllergyError = "GET_REMOVE_ALLERGY_ERROR";
export const SetAllergySchema = "SET_ALLERGY_SCHEMA";
export const RemoveAllergy = "REMOVE_ALLERGY";
export const RemoveAllergySuccess = "REMOVE_ALLERGY_SUCCESS";
export const RemoveAllergyError = "REMOVE_ALLERGY_ERROR";
export const GetMedicalHistorySchema = "GET_MEDICAL_HISTORY_SCHEMA";
export const SetMedicalHistorySchema = "SET_MEDICAL_HISTORY_SCHEMA";
export const GetEmployeeMedicalHistorySuccess = "GET_EMPLOYEE_MEDICAL_HISTORY_SUCCESS";
export const GetEmployeeMedicalHistoryError = "GET_EMPLOYEE_MEDICAL_HISTORY_ERROR";
export const AddMedicalHistoryItem = "ADD_MEDICAL_HISTORY_ITEM";
export const AddMedicalHistoryItemSuccess = "ADD_MEDICAL_HISTORY_ITEM_SUCCESS";
export const AddMedicalHistoryItemError = "ADD_MEDICAL_HISTORY_ITEM_ERROR";
export const RemoveMedicalHistoryItem = "REMOVE_MEDICAL_HISTORY_ITEM";
export const RemoveMedicalHistoryItemSuccess = "REMOVE_MEDICAL_HISTORY_ITEM_SUCCESS";
export const RemoveMedicalHistoryItemError = "REMOVE_MEDICAL_HISTORY_ITEM_ERROR";
export const GetAddMedicalHistoryItemError = "GET_ADD_MEDICAL_HISTORY_ITEM_ERROR";
export const GetMedicalDetailsChangelog = "GET_MEDICAL_DETAILS_CHANGELOG";
export const GetMedicalDetailsChangelogSuccess = "GET_MEDICAL_DETAILS_CHANGELOG_SUCCESS";
export const GetMedicalDetailsChangelogError = "GET_MEDICAL_DETAILS_CHANGELOG_ERROR";
export const SetEmployeeMedicationSort = "SET_EMPLOYEE_MEDICATION_SORT";
export const SetEmployeeAllergySort = "SET_EMPLOYEE_ALLERGY_SORT";
export const SetEmployeeMedicalHistorySort = "SET_EMPLOYEE_MEDICAL_HISTORY_SORT";
export const SetAbsencesSort = "SET_ABSENCES_SORT";

// User Account Details
export const ToggleEditAccountDetailsModal = "TOGGLE_EDIT_ACCOUNT_DETAILS_MODAL";
export const ToggleEditResetPasswordModal = "TOGGLE_EDIT_RESET_PASSWORD";
export const ToggleConfirmResetPasswordModal = "TOGGLE_CONFIRM_RESET_PASSWORD_MODAL";
export const BlockUserAccount = "BLOCK_USER_ACCOUNT";
export const BlockUserAccountSuccess = "BLOCK_USER_ACCOUNT_SUCCESS";
export const BlockUserAccountError = "BLOCK_USER_ACCOUNT_ERROR";
export const UnblockUserAccount = "UNBLOCK_USER_ACCOUNT";
export const UnblockUserAccountSuccess = "UNBLOCK_USER_ACCOUNT_SUCCESS";
export const UnblockUserAccountError = "UNBLOCK_USER_ACCOUNT_ERROR";
export const UnlockUserAccount = "UNLOCK_USER_ACCOUNT";
export const UnlockUserAccountSuccess = "UNLOCK_USER_ACCOUNT_SUCCESS";
export const UnlockUserAccountError = "UNLOCK_USER_ACCOUNT_ERROR";
export const ResetUserAccountPassword = "RESET_USER_ACCOUNT_PASSWORD";
export const ResetUserAccountPasswordSuccess = "RESET_USER_ACCOUNT_PASSWORD_SUCCESS";
export const ResetUserAccountPasswordError = "RESET_USER_ACCOUNT_PASSWORD_ERROR";
export const GetUserRecentLogins = "GET_USER_RECENT_LOGINS";
export const GetUserRecentLoginsSuccess = "GET_USER_RECENT_LOGINS_SUCCESS";
export const GetUserRecentLoginsError = "GET_USER_RECENT_LOGINS_ERROR";
export const GetUserAccountChangelog = "GET_USER_ACCOUNT_CHANGE_LOG";
export const GetUserAccountChangelogSuccess = "GET_USER_ACCOUNT_CHANGE_LOG_SUCCESS";
export const GetUserAccountChangelogError = "GET_USER_ACCOUNT_CHANGE_LOG_ERROR";
export const GetUserAccount = "GET_USER_ACCOUNT";
export const GetUserAccountSuccess = "GET_USER_ACCOUNT_SUCCESS";
export const GetUserAccountError = "GET_USER_ACCOUNT_ERROR";
export const UpdateUserAccount = "UPDATE_USER_ACCOUNT";
export const UpdateUserAccountSuccess = "UPDATE_USER_ACCOUNT_SUCCESS";
export const UpdateUserAccountError = "UPDATE_USER_ACCOUNT_ERROR";
export const GetAccessLevelSchema = "GET_ACCESS_LEVEL_SCHEMA";
export const GetAccessLevelSchemaSuccess = "GET_ACCES_LEVEL_SCHEMA_SUCCESS";
export const GetAccessLevelSchemaError = "GET_ACCES_LEVEL_SCHEMA_ERROR";
export const UpdateAccessLevel = "UPDATE_ACCESS_LEVEL";
export const UpdateAccessLevelSuccess = "UPDATE_ACCESS_LEVEL_SUCCESS";
export const UpdateAccessLevelError = "UPDATE_ACCESS_LEVEL_ERROR";
export const GetAccessLevelValueSuccess = "GET_ACCESS_LEVEL_VALUE_SUCCESS";
export const GetUserAccountAssignments = "GET_USER_ACCOUNT_ASSIGNMENTS";
export const GetUserAccountAssignmentsSuccess = "GET_USER_ACCOUNT_ASSIGNMENTS_SUCCESS";
export const GetUserAccountAssignmentsError = "GET_USER_ACCOUNT_ASSIGNMENTS_ERROR";
export const UpdateUserAccountAssignments = "UPDATE_USER_ACCOUNT_ASSIGNMENTS";
export const UpdateUserAccountAssignmentsSuccess = "UPDATE_USER_ACCOUNT_ASSIGNMENTS_SUCCESS";
export const UpdateUserAccountAssignmentsError = "UPDATE_USER_ACCOUNT_ASSIGNMENTS_ERROR";
export const ToggleUserAccountAssignmentsModal = "TOGGLE_USER_ACCOUNT_ASSIGNMENTS_MODAL";
export const ToggleUserAccountImpersonateModal = "TOGGLE_USER_ACCOUNT_IMPERSONATE_MODAL";
export const ResetUserOtp = "RESET_USER_OTP";
export const ResetUserOtpSuccess = "RESET_USER_OTP_SUCCESS";
export const ResetUserOtpError = "RESET_USER_OTP_ERROR";

// My Details
export const ChangePassword = "CHANGE_PASSWORD";
export const ChangePasswordSuccess = "CHANGE_PASSWORD_SUCCESS";
export const ChangePasswordError = "CHANGE_PASSWORD_ERROR";
export const GetContactInfoSchema = "GET_CONTACT_INFO_SCHEMA";
export const GetContactInfoSchemaSuccess = "GET_CONTACT_INFO_SCHEMA_SUCCESS";
export const GetContactInfoSchemaError = "GET_CONTACT_INFO_SCHEMA_ERROR";

export const GetMyDetails = "GET_MY_DETAILS";
export const GetMyDetailsSuccess = "GET_MY_DETAILS_SUCCESS";
export const GetMyDetailsError = "GET_MY_DETAILS_ERROR";
export const UpdateContactInfo = "UPDATE_CONTACT_INFO";
export const UpdateContactInfoSuccess = "UPDATE_CONTACT_INFO_SUCCESS";
export const UpdateContactInfoError = "UPDATE_CONTACT_INFO_ERROR";
export const ChangeEmployeeFilterInitialValues = "CHANGE+EMPLOYEE_FILTER_INITIAL_VALUES";
